import { render, staticRenderFns } from "./OfferTypeButton.vue?vue&type=template&id=4b964df6&scoped=true&"
import script from "./OfferTypeButton.vue?vue&type=script&lang=js&"
export * from "./OfferTypeButton.vue?vue&type=script&lang=js&"
import style0 from "./OfferTypeButton.vue?vue&type=style&index=0&id=4b964df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b964df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
